(function() {
	PM.Integrations = {};

	$(document).on('click', '.js-integrations-toggle', function() {
		$('.integrations-submenu').toggleClass('d-none');
		$('.integration-chevron').toggleClass('collapsed');
	});

	page('/config/integrations', PM.Shell.routeWithPermission('view_integrations', function() {
		page.redirect('/config/integrations/jira');
	}));

	page('/config/integrations/jira', PM.Shell.routeWithPermission('view_integrations', function() {
		PM.JiraIntegration.renderSection();
	}));

	page('/config/integrations/mcp', PM.Shell.routeWithPermission('view_integrations', function() {
		PM.McpIntegration.renderSection();
	}));

	page('/config/integrations/api', PM.Shell.routeWithPermission('view_integrations', function() {
		PM.ApiIntegration.renderSection();
	}));
})();
